import { fontRanges } from "../foundations"

const {
  xs,
  sm,
  md,
  lg,
  xl,
  "2xl": twoXL,
  "3xl": threeXL,
  "4xl": fourXL,
  "5xl": fiveXL,
  "6xl": sixXL,
} = fontRanges

const heading = {
  baseStyle: {
    lineHeight: "normal",
    fontWeight: "normal",
  },

  sizes: {
    xs: {
      fontSize: xs.fontSize,
      lineHeight: "1.5",
    },
    sm: {
      fontSize: sm.fontSize,
      lineHeight: "1.5",
    },
    md: {
      fontSize: md.fontSize,
      lineHeight: "1.5",
    },
    lg: {
      fontSize: lg.fontSize,
      lineHeight: "1.5",
    },
    xl: {
      fontSize: xl.fontSize,
      lineHeight: "1.5",
    },
    "2xl": {
      fontSize: twoXL.fontSize,
      lineHeight: "1.5",
    },
    "3xl": {
      fontSize: threeXL.fontSize,
      lineHeight: "1.5",
    },
    "4xl": {
      fontSize: fourXL.fontSize,
      lineHeight: "1.5",
    },
    "5xl": {
      fontSize: fiveXL.fontSize,
      lineHeight: "1.5",
    },
    "6xl": {
      fontSize: sixXL.fontSize,
      lineHeight: "1.5",
    },
  },

  defaultProps: {
    size: "4xl",
  },
}

export default heading
